/**
 * Loads i18next translation resources from JSON files. Uses require() with
 * static paths so the build includes the JSON files. To add a locale or
 * namespace, add the require below and extend LOCALES/NAMESPACES.
 */

import { ALL_LOCALES, Locale } from "./locales";

const NAMESPACES = ["i18n", "web", "return-app", "model"] as const;

type Namespace = (typeof NAMESPACES)[number];
type ModuleKey = `${Locale}/${Namespace}`;
type TranslationRecord = Record<string, string>;

// Static paths required so bundler/Bazel can include these JSON files
/* eslint-disable @typescript-eslint/no-require-imports */
const enI18n = require("./en/i18n.json") as TranslationRecord;
const enWeb = require("./en/web.json") as TranslationRecord;
const enReturnApp = require("./en/return-app.json") as TranslationRecord;
const enModel = require("./en/model.json") as TranslationRecord;
const esI18n = require("./es/i18n.json") as TranslationRecord;
const esWeb = require("./es/web.json") as TranslationRecord;
const esReturnApp = require("./es/return-app.json") as TranslationRecord;
const esModel = require("./es/model.json") as TranslationRecord;
const frI18n = require("./fr/i18n.json") as TranslationRecord;
const frWeb = require("./fr/web.json") as TranslationRecord;
const frReturnApp = require("./fr/return-app.json") as TranslationRecord;
const frModel = require("./fr/model.json") as TranslationRecord;
/* eslint-enable @typescript-eslint/no-require-imports */

const modules: Record<ModuleKey, TranslationRecord> = {
  "en/i18n": enI18n,
  "en/web": enWeb,
  "en/return-app": enReturnApp,
  "en/model": enModel,
  "es/i18n": esI18n,
  "es/web": esWeb,
  "es/return-app": esReturnApp,
  "es/model": esModel,
  "fr/i18n": frI18n,
  "fr/web": frWeb,
  "fr/return-app": frReturnApp,
  "fr/model": frModel,
};

export function getI18nResources(): Record<
  string,
  { translation: TranslationRecord }
> {
  const resources: Record<string, { translation: TranslationRecord }> = {};
  for (const locale of ALL_LOCALES) {
    resources[locale] = { translation: {} };
    for (const namespace of NAMESPACES) {
      const data = modules[`${locale}/${namespace}`];
      if (data) {
        Object.assign(resources[locale].translation, data);
      }
    }
  }
  return resources;
}
